module.exports = __webpack_public_path__ + "static/media/7.203a5457.jpg";